// bd-deepcontext-b4zw — per-job daily volume/cost, lifted out of
// ScheduledJobs.tsx.
import { estimateDailyCost } from "../../utils/analysisCost";
import type { ScheduledJob } from "./types";

export const calculateJobDailyStats = (
  job: Pick<ScheduledJob, "runsPerDay" | "urlsPerRun">,
): { dailyUrls: number; estimatedCost: number } => {
  // Unified job model (deepcontext-ia8xo.1): daily URLs = runsPerDay × urlsPerRun.
  const dailyUrls = job.runsPerDay * job.urlsPerRun;
  // Per-URL rate derived from the analysis model's real pricing — single
  // source of truth in utils/analysisCost.ts (mirrors the backend), NOT a
  // hardcoded 0.0006 literal.
  const estimatedCost = estimateDailyCost(dailyUrls);

  return {
    dailyUrls,
    estimatedCost,
  };
};
